import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveUrl } from "~/utils/url/urlResolver";
import { OrderQuoteSettingsAPI } from "./staticPaths";
import {
  type AccountInfoData,
  type AccountInfoDTO,
} from "~/features/b2bAccountSelection/components/AccountSelectionTabelView/api/GetAccountList";

export const getList = () => callEndPoint({ url: OrderQuoteSettingsAPI.LIST, method: "GET" }).then(tranform);
// export const updateAccount = (data: any) => callEndPoint({ url: OrderQuoteSettingsAPI.UPDATE, method: "PUT", data });
export const saveAccount = (data: any) => callEndPoint({ url: OrderQuoteSettingsAPI.SAVE, method: "POST", data });
// export const editAccount = (data: any) => callEndPoint({ url: OrderQuoteSettingsAPI.EDIT, method: "PUT", data });
export const deleteAccount = (data: any) => callEndPoint({ url: OrderQuoteSettingsAPI.DELETE, method: "DELETE", data });

interface EnpointCallData {
  url: string;
  method: string;
  data?: OrderAndQuoteAccountData;
}
const callEndPoint = ({ url, method, data }: EnpointCallData) =>
  fetch(resolveUrl("/my-account" + url), {
    body: data ? JSON.stringify(tranformBack(data)) : null,
    cache: "no-cache",
    credentials: "same-origin",
    method,
    mode: "cors",
    headers: {
      CSRFToken: getCsrfValue(),
      "content-type": "application/json",
    },
    redirect: "follow",
  }).then((data) => data.json().catch(() => ""));

interface OrderAndQuoteAccountDTO {
  recipientEmail: string;
  orderCCAcknowledgementAccounts: AccountInfoDTO[];
  quoteCCAcknowledgementAccounts: AccountInfoDTO[];
}

export interface OrderAndQuoteAccountData {
  recipientEmail: string;
  orderAcknowledgement: AccountInfoData[];
  quoteAcknowledgement: AccountInfoData[];
}

const tranform = (data: OrderAndQuoteAccountDTO[]): OrderAndQuoteAccountData[] =>
  data.map((entry) => ({
    recipientEmail: entry.recipientEmail ?? "",
    orderAcknowledgement: transformAccountData(entry.orderCCAcknowledgementAccounts),
    quoteAcknowledgement: transformAccountData(entry.quoteCCAcknowledgementAccounts),
  }));

const tranformBack = (data: OrderAndQuoteAccountData): OrderAndQuoteAccountDTO => ({
  recipientEmail: data.recipientEmail,
  orderCCAcknowledgementAccounts: transformAccountDataBack(data.orderAcknowledgement),
  quoteCCAcknowledgementAccounts: transformAccountDataBack(data.quoteAcknowledgement),
});

const transformAccountData = (data: AccountInfoDTO[]): AccountInfoData[] =>
  data.map((item) => ({
    id: `${item.uid}-${item.salesOrg}-${item.currency}-${item.endCustomerCode}`,
    uid: item.uid,
    number: item.displayUid,
    name: item.name,
    currency: item.currency,
    region: item.region ?? "",
    salesOrg: item.salesOrg,
    isDefault: !!item.defaultAccount,
    isSelected: !!item.defaultAccount,
    endCustomerCode: item.endCustomerCode ?? "",
    endCustomerName: item.endCustomerName ?? "",
    endCustomerType: item.endCustomerType ?? "",
    endCustomerSector: item.endCustomerSector ?? "",
    country: item.country ?? "",
  }));

const transformAccountDataBack = (data: AccountInfoData[]): AccountInfoDTO[] =>
  data.map((item) => ({
    uid: item.uid,
    displayUid: item.number,
    name: item.name,
    currency: item.currency,
    region: item.region ?? "",
    salesOrg: item.salesOrg,
    defaultAccount: !!item.isDefault,
    endCustomerCode: item.endCustomerCode ?? "",
    endCustomerName: item.endCustomerName ?? "",
    endCustomerType: item.endCustomerType ?? "",
    endCustomerSector: item.endCustomerSector ?? "",
    country: item.country ?? "",
  }));
